module.exports = __webpack_public_path__ + "e037514fdcc283fba35f411ff44a837b.woff2";